import {create} from 'zustand';
import {createSelectors} from './zustand';

export const INFO = 'INFO';
export const ERROR = 'ERROR';
export const SUCCESS = 'SUCCESS';
export type ToastType = typeof INFO | typeof ERROR | typeof SUCCESS;
export interface ToastMessage {
    type: ToastType;
    message: string;
    open: boolean;
}

interface AppState {
    toast: ToastMessage;
    setToast: (toast: ToastMessage) => void;
    clearToast: () => void;
}

const BASE_TOAST: ToastMessage = {type: INFO, message: '', open: false};

export const useAppStoreBase = create<AppState>()((set) => ({
    toast: BASE_TOAST,
    setToast: (toast) => set(() => ({toast})),
    clearToast: () => set(() => ({toast: BASE_TOAST})),
}));

export const useAppStore = createSelectors(useAppStoreBase);
